import { render, staticRenderFns } from "./OverviewResources.vue?vue&type=template&id=4bbd0af4&scoped=true"
import script from "./OverviewResources.vue?vue&type=script&lang=ts"
export * from "./OverviewResources.vue?vue&type=script&lang=ts"
import style0 from "./OverviewResources.vue?vue&type=style&index=0&id=4bbd0af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd0af4",
  null
  
)

export default component.exports